import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "clearValue", "cx", "data", "getStyles", "getValue", "hasValue", "isDisabled", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import { components } from '@atlaskit/select';

/**
 * This creates a functional component that `react-select` will use to make the
 * SingleValue part of the different pickers.
 */
export var makeSingleValue =
// TODO: Make ID required
function makeSingleValue(_ref) {
  var id = _ref.id,
    lang = _ref.lang;
  return function (_ref2) {
    var children = _ref2.children,
      className = _ref2.className,
      clearValue = _ref2.clearValue,
      cx = _ref2.cx,
      data = _ref2.data,
      getStyles = _ref2.getStyles,
      getValue = _ref2.getValue,
      hasValue = _ref2.hasValue,
      isDisabled = _ref2.isDisabled,
      isMulti = _ref2.isMulti,
      isRtl = _ref2.isRtl,
      options = _ref2.options,
      selectOption = _ref2.selectOption,
      selectProps = _ref2.selectProps,
      setValue = _ref2.setValue,
      rest = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(components.SingleValue, _extends({}, rest, {
      // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
      className: className,
      clearValue: clearValue,
      cx: cx,
      data: data,
      getStyles: getStyles,
      getValue: getValue,
      hasValue: hasValue,
      innerProps: _objectSpread(_objectSpread({}, fg('platform-dtp_a11y_fix-dsp-23950') ? {
        id: id
      } : {}), {}, {
        lang: lang
      }),
      isDisabled: isDisabled,
      isMulti: isMulti,
      isRtl: isRtl,
      options: options,
      selectOption: selectOption,
      selectProps: selectProps,
      setValue: setValue
    }), children);
  };
};